let timers = {}; // To store timer intervals for each video
let openTimes = {}; // To track open times for each video
const localStorageKeyPrefix = 'videoWatchTime_'; // Prefix for localStorage keys
var
  persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
  arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g],
  fixNumbers = function (str) {
    if (typeof str === 'string') {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  };
// Initialize all sections to be closed
$('.section_slide').slideUp(0);
$('.slide-item').slideUp(0);

// Accordion click event
$('.player-item .tab_click').on('click', function () {
  var sectionSlide = $(this).parent().find('.section_slide');
  var player = $(this).parent().find('.videoPlayer');
  var arrow = $(this).find('.arrow_down');
  var videoId = $(this).data('session'); // Using session ID as video ID
  var time = $(this).data('time'); // Using session ID as video ID
  var src = $(this).data('frame'); // Using session ID as video ID
  let timer = fixNumbers(time)
  const [minutes, seconds] = timer.split(':');
  const videoDuration = (+minutes) * 60 + (+seconds);
  if (!player.prop('src'))
    player.prop('src', src)

  // Toggle the accordion
  sectionSlide.slideToggle();
  arrow.toggleClass('rotate180');

  // If it's opened, start tracking time
  if (arrow.hasClass('rotate180')) {
    // Start the timer for the video
    startTimer(videoId, videoDuration);
  } else {
    // If closed, stop the timer
    clearInterval(timers[videoId]); // Stop the timer
    localStorage.setItem(localStorageKeyPrefix + videoId, openTimes[videoId]); // Save time to localStorage
    openTimes[videoId] = 0; // Reset open time
  }
});
$('.main_tab .tab_click').on('click', function () {
  var sectionSlide = $(this).parent().find('.slide-item');
  var arrow = $(this).parent().find('.box_arrow_down');
  // Toggle the accordion
  sectionSlide.slideToggle();
  arrow.toggleClass('rotate180');

});

// Function to start the timer for a specific video
function startTimer(videoId, videoDuration) {
  openTimes[videoId] = 0; // Reset open time for the video
  const previousWatchTime = localStorage.getItem(localStorageKeyPrefix + videoId);

  // If there's a previous watch time, set it
  if (previousWatchTime) {
    openTimes[videoId] = parseInt(previousWatchTime, 10);
  }

  timers[videoId] = setInterval(function () {
    openTimes[videoId] += 1; // Increment time
    const watchedPercentage = (openTimes[videoId] / videoDuration) * 100;

    // Update progress display
    // Check if 90% has been watched
    if (watchedPercentage >= 70) {
      clearInterval(timers[videoId]); // Stop the timer
      submitWatchStatus(videoId); // Submit the watch status to the server
    }
  }, 1000); // Update every second
}

// Function to submit watch status to the server
function submitWatchStatus(videoId) {
  var url = $(`.tab_click[data-session="${videoId}"]`).data('url');
  jQuery.ajax({
    url: url,
    type: 'POST',
    data: {
      action: 'mark_session_watched',
      session_id: videoId
    },
    success: function (response) {
      if (response.success) {
        localStorage.removeItem(localStorageKeyPrefix + videoId); // Clear localStorage entry after success
      } else {
      }
    },
    error: function (error) {
      console.error(`Error submitting watch status for ${videoId}:`, error);
    }
  });
}

// Load previous watch times from localStorage when the page is loaded
$(document).ready(function () {
  $('.session').each(function () {
    const videoId = $(this).data('session');
    const previousWatchTime = localStorage.getItem(localStorageKeyPrefix + videoId);
    if (previousWatchTime) {
      openTimes[videoId] = parseInt(previousWatchTime, 10);
      const videoDuration = 60; // Assume duration in seconds
      const watchedPercentage = (openTimes[videoId] / videoDuration) * 100;
    } else {
      openTimes[videoId] = 0; // Initialize if not found
    }
  });
// Ensure jQuery is loaded and available

});

function getCookie(name) {
  var dc = document.cookie;
  var prefix = name + "=";
  var begin = dc.indexOf("; " + prefix);
  if (begin == -1) {
    begin = dc.indexOf(prefix);
    if (begin != 0) return null;
  } else {
    begin += 2;
    var end = document.cookie.indexOf(";", begin);
    if (end == -1) {
      end = dc.length;
    }
  }
  // because unescape has been deprecated, replaced with decodeURI
  //return unescape(dc.substring(begin + prefix.length, end));
  return decodeURI(dc.substring(begin + prefix.length, end));
}

function getQueryString(param) {
  return decodeURIComponent(
    (location.search.match(RegExp("[?|&]" + param + '=(.+?)(&|$)')) || [, null])[1]
  );
}

jQuery(document).ready(function ($) {
  let params = new URL(document.location.toString()).searchParams;
  let checked = params.get("checked");
  // Assume `getAppSysInfo` is defined and returns device info
  const deviceInfo = typeof appGetSysInfo === 'function' ? appGetSysInfo() : null;
  const productId = $('#license').data('product');
  const check = $('#license').data('check');
  const bought = $('#license').data('bought');
  const has_licence = $('#license').data('licence');
  const is_registered = $('#license').data('registered');

  if (is_registered && deviceInfo && has_licence && bought && !checked && productId && !getCookie('serial_number_' + productId)) {
    window.location.href = check;
  }

});

jQuery(document).ready(function ($) {
  $('#activate-license').on('click', function () {
    const productId = $(this).data('product-id');
    const ajax_url = $("#ajax-url").val();

    $.post(ajax_url, {
      action: 'activate_license',
      product_id: productId,
    }, function (response) {
      alert(response.data.message);
      if (response.success){
        location.reload()
      }
    });
  });

});
